import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectVoucher } from '../../../../cartAndOrders/store/slice'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Loading } from '../../../../common/loading'
import { Popup } from '../../../../common/popup'
import classes from '../../../index.module.scss'
import {
  selectBuyPackage,
  selectIsLoadingDownload,
  selectQuotationForm,
  selectSubscriptionDetailsParams,
  setQuotationForm,
} from '../../store/slice'
import { getSampleQuotations, postQuotations } from '../../store/thunk'
import { checkInvalidInputVal, removeEmptyItem } from '../helper'
import { QuotationForm } from './QuotationForm'
import { IS_VALID_FIELDS, QUOTATION_FIELD_KEYS } from './constants'

export const PopupQuotation = ({
  isShow,
  setIsShow,
  isBuyPackage,
  userProfile,
  loadingUserProfile,
}) => {
  const dispatch = useDispatch()

  const form = useSelector(selectQuotationForm)
  const buyPackage = useSelector(selectBuyPackage)

  const isLoadingDownload = useSelector(selectIsLoadingDownload)
  const subscriptionDetails = useSelector(selectSubscriptionDetailsParams)
  const dataVoucher = useSelector(selectVoucher)

  const listPackage = buyPackage?.listPackage

  const [isValid, setIsValid] = useState(IS_VALID_FIELDS)

  const handleClose = () => {
    setIsShow(false)
    setIsValid(IS_VALID_FIELDS)
  }

  const setForm = (form) => {
    dispatch(setQuotationForm(form))
  }

  const handleGetSampleQuotations = () => {
    dispatch(getSampleQuotations())
  }

  const downloadQuotation = () => {
    let packageParams = {}
    let packageDetails = []
    let subscriptionParams = {}

    if (form) {
      const checkValidRequiredField = Object.values(QUOTATION_FIELD_KEYS).map(
        (item) => ({
          [item]: !checkInvalidInputVal(form[item]),
        }),
      )
      const isValidAllField = {
        ...isValid,
        ...Object.assign({}, ...checkValidRequiredField),
      }

      setIsValid(isValidAllField)

      if (Object.values(isValidAllField).includes(false)) {
        return
      }
    }

    if (listPackage.length) {
      packageDetails = listPackage.map((item) => ({
        fiinGateReportTypeId: item.packageTypeId,
        pricingPackageId: item.pricingPackageId,
        quantity: Number(item.volume),
        price: item.unitPrice,
      }))
    }

    if (!isBuyPackage) {
      packageParams = {}
    } else {
      packageParams = {
        details: packageDetails,
        discountId: 0,
        voucherCode: dataVoucher?.code,
      }
    }

    if (subscriptionDetails) {
      subscriptionParams = subscriptionDetails
    } else {
      subscriptionParams = {}
    }

    const params = {
      data: removeEmptyItem({
        package: packageParams,
        ...form,
        subscription: subscriptionParams,
        phone: form?.companyPhone,
      }),
    }

    dispatch(postQuotations(params))
      .unwrap()
      .then(() => {
        setIsShow(false)
      })
  }

  return (
    <>
      {isShow && (
        <Popup zIndexPopup={99}>
          {
            <div className={[classes.popupBuyPackage].join(' ')}>
              <Element
                className={[
                  'dFlex justifyContentBetween alignItemsCenter',
                  classes.header,
                ].join(' ')}
                style={{
                  borderBottom: '1px solid #e5e5e8',
                }}
              >
                <Element
                  elementName="span"
                  style={{
                    fontSize: 20,
                    fontWeight: 500,
                    lineHeight: '24px',
                    color: '#0553A5',
                    width: `calc(100% - 30px)`,
                  }}
                >
                  <Translate value="userManagement.quotationInfo.QUOTATION_INFO" />
                </Element>
                <Element onClick={handleClose}>
                  <Icon
                    className="icon-delete"
                    style={{ fontSize: 12, color: '#9C9C9C' }}
                  />
                </Element>
              </Element>
              <Element
                className="dFlex justifyContentEnd"
                style={{ color: '#2C73E8', marginTop: 12 }}
              >
                <Element
                  onClick={handleGetSampleQuotations}
                  elementName="span"
                  className="cursorPointer"
                >
                  <Translate value="userManagement.quotationInfo.SAMPLE_QUOTATION" />
                </Element>
              </Element>
              <QuotationForm
                form={form}
                setForm={setForm}
                isValid={isValid}
                setIsValid={setIsValid}
                userProfile={userProfile}
                loadingUserProfile={loadingUserProfile}
              />
            </div>
          }
          <div className="dFlex justifyContentEnd">
            <Element
              style={{
                border: 'none',
                backgroundColor: '#2C73E8',
                color: '#FFFFFF',
                padding: '6px 12px',
                borderRadius: '4px',
                fontSize: 12,
                cursor: isLoadingDownload ? 'none' : 'pointer',
                opacity: isLoadingDownload ? 0.6 : '',
              }}
              className="positionRelative"
              onClick={downloadQuotation}
            >
              {isLoadingDownload && <Loading />}
              <Translate value="userManagement.quotationInfo.DOWNLOAD_QUOTATION" />
            </Element>
          </div>
        </Popup>
      )}
    </>
  )
}
